import "../../pages/reports/gce-o.css";
import { ExamType } from "../../types/types";

interface SubjectData {
  code: string;
  name: string;
  student_count: string | number;
}

interface BEPCSubjectsTableProps {
  registrationData: {
    exam_registration?: {
      subject_categories?: Record<string, SubjectData[]>;
    } | null;
  } | null;
  selectedExamTypes: ExamType[];
}

const BEPCSubjectsTable: React.FC<BEPCSubjectsTableProps> = ({
  registrationData,
  selectedExamTypes,
}) => {
  const shouldRenderTables = selectedExamTypes.some((et) =>
    et.name.includes("BEPC")
  ); // Use .some() instead of finding the exact one and checking

  if (!shouldRenderTables) return null;

  const bepcBil =
    registrationData?.exam_registration?.subject_categories?.BEPCBil || [];
  const bepcOrd =
    registrationData?.exam_registration?.subject_categories?.BEPCOrd || [];

  const ordMap = new Map(bepcOrd.map((s) => [s.code, s]));
  const bilMap = new Map(bepcBil.map((s) => [s.code, s]));

  const merged = [];
  const ordOnly = [];
  const bilOnly = [];

  for (const [code, subj] of ordMap) {
    if (bilMap.has(code)) {
      merged.push({
        code,
        name: subj.name,
        ordCount: subj.student_count,
        bilCount: bilMap.get(code)!.student_count,
      });
    } else {
      ordOnly.push({
        code,
        name: subj.name,
        ordCount: subj.student_count,
      });
    }
  }

  for (const [code, subj] of bilMap) {
    if (!ordMap.has(code)) {
      bilOnly.push({
        code,
        name: subj.name,
        bilCount: subj.student_count,
      });
    }
  }

  return (
    <table className="gceo-subjects-table">
      <tbody>
        <tr>
          <th colSpan={4}>MATIERES / SERIES</th>
          <th># of Candidates BEPC Ord </th>
          <th># of Candidates BEPC Bil. </th>
        </tr>
        {merged.map((sub) => (
          <tr key={sub.code}>
            <td colSpan={4}>
              {sub.code} {sub.name}
            </td>
            <td>{sub.ordCount}</td>
            <td>{sub.bilCount}</td>
          </tr>
        ))}
        {ordOnly.map((sub) => (
          <tr key={sub.code}>
            <td colSpan={4}>
              {sub.code} {sub.name}
            </td>
            <td>{sub.ordCount}</td>
            <td>N/A</td>
          </tr>
        ))}
        {bilOnly.map((sub) => (
          <tr key={sub.code}>
            <td colSpan={4}>
              {sub.code} {sub.name}
            </td>
            <td>N/A</td>
            <td>{sub.bilCount}</td>
          </tr>
        ))}
      </tbody>
    </table>
  );
};

export default BEPCSubjectsTable;
